import React from "react";

const BingoPlayersList = ({ players }) => {
  return (
    <>
      {players.map((player) => (
        <div className="player-profile">
          <img src={player.profile_image} alt="player-img" />
          <span className="profile-name">{player.display_name}</span>
        </div>
      ))}
    </>
  );
};

export default BingoPlayersList;
